<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { ProductListInfinite } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import ProductList from './components/ProductList.svelte';

    // TYPES
    import type { Auction } from 'src/app/types';

    /* EXPORTS --------------------------------------------------------------------------------- */

    export let auctionKey: string | undefined;
    export let auction: Auction;
    export let isPreview: boolean;

    /* INITIALIZE ------------------------------------------------------------------------------ */

    const PARAMETERS = { auctionKey, showOnlyMatches: false };

    /* INTERNALS ------------------------------------------------------------------------------- */

</script>

<ProductListInfinite parameters = { PARAMETERS } { isPreview } let:products let:isLoading let:isEndOfList>
    <!-- TODO: Fix product type on SDK -->
    <ProductList { products } { auction } { isPreview } { isLoading } { isEndOfList }/>
</ProductListInfinite>